import { render } from "./SigninScreen.vue?vue&type=template&id=74e22708"
import script from "./SigninScreen.vue?vue&type=script&lang=js"
export * from "./SigninScreen.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src767714679/src/centaurapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__